import styled from "styled-components";
import {
  CommonCard,
  SectionLastHeading,
  GeminiViewContainer
} from "../../../../CommonComponents/commonStyles";
import { Row } from "antd";

export const OptionsCard = styled(CommonCard)`  
  margin-bottom: 20px;
  @media only screen and (max-width: 990px) {
  }
  @media only screen and (max-width: 576px) {
    padding: 10px 20px 30px 20px;
  }
`;
export const CharityList = styled(Row)`
  &.ant-row {
    display: flex;
    flex-wrap: wrap;
  }
`;

export const ContentData = styled.div`  
  padding: 10px 30px 20px 30px; 
`;
export const HeaderData = styled.div`
  padding: 10px 30px 20px 30px;
  position: relative;
  width: 80%;
  @media only screen and (max-width: 990px) {
  }
  @media only screen and (max-width: 576px) {
    width: 100%;
  }
`;

export const NotesStringContainer = styled.div`

`;

export const GeminiViewContainerWithNotes = styled(GeminiViewContainer)`
  margin-left: 20px;
`;

export const NotesDataContainer = styled.div`
  margin-left: 8px;
`;

export const SectionPercentage = styled(SectionLastHeading)`
  @media only screen and (min-width: 767.92px) {
    position: absolute;
    right: -22%;
    top: 41%;
  }
  @media print{
    position: absolute;
    right: -22%;
    top: 41%;
  }
  @media only screen and (max-width: 576px) {
  }
`;

export const CharityIcon = styled.img`
  margin-top: -10px;
`;

export const UnderLine = styled.span`
  font-family: ${props => props.theme.fontFamily.helveticaNeue};
  font-size: ${props => props.theme.fontSize.primary};
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: ${props => props.theme.lineHeight.primary};
  color:  ${props => props.theme.fontColors.primary};
  text-decoration: underline;
  cursor: pointer;
  @media only screen and (max-width:767px){
    font-size: ${props => props.theme.fontSize.secondary}
  }
`;

export const Percentage = styled.div`
  font-family: ${props => props.theme.fontFamily.berkeleyStdBold};
  font-size: ${props => props.theme.fontSize.h4};
  line-height: 1.17;
  color: ${props => props.textColor};  
`;

export const PercentageImage = styled.div`
    margin-bottom: 15px;
    font-family: ${props => props.theme.fontFamily.helveticaNeueBold};
    font-size: ${props => props.theme.fontSize.primary};
    line-height: ${props => props.theme.lineHeight.primary};
    color: ${props => props.theme.fontColors.headingColor};
    >img {
      margin-right: 10px;
    } 

    @media only screen and (max-width:767px){
      font-size: ${props => props.theme.fontSize.secondary}
      line-height: ${props => props.theme.lineHeight.secondary};
    }
`;

export const PercentageOthers = styled.div`
  margin:0px 32px;
  font-family: ${props => props.theme.fontFamily.helveticaNeueBold};
  font-size: ${props => props.theme.fontSize.primary};
  line-height: ${props => props.theme.lineHeight.primary};
  color: ${props => props.theme.fontColors.headingColor};
  @media only screen and (max-width:767px){
    font-size: ${props => props.theme.fontSize.secondary}
    line-height: ${props => props.theme.lineHeight.secondary};
  }
`;